{
  "settings": {
    "title": "Configurações da conta",
    "subtitle": "Gerencie seu e-mail, senha e status da conta.",
    "needHelp": "Precisa de ajuda? Entre no nosso Discord"
  },
  "changeEmail": {
    "title": "Alterar endereço de e-mail",
    "subtitle": "Alterar seu e-mail exigirá que você reconfirme seu endereço. Você será desconectado de todas as sessões.",
    "newEmailLabel": "Novo endereço de e-mail",
    "newEmailPlaceholder": "Digite o novo e-mail",
    "currentPasswordLabel": "Senha atual",
    "currentPasswordPlaceholder": "Digite a senha atual",
    "submitButton": "Atualizar endereço de e-mail",
    "submittingButton": "Atualizando..."
  },
  "changePassword": {
    "title": "Alterar senha",
    "subtitle": "Atualize sua senha. Você continuará conectado neste dispositivo.",
    "currentPasswordLabel": "Senha atual",
    "currentPasswordPlaceholder": "Digite a senha atual",
    "newPasswordLabel": "Nova senha",
    "newPasswordPlaceholder": "Digite a nova senha",
    "confirmPasswordLabel": "Confirmar nova senha",
    "confirmPasswordPlaceholder": "Confirme a nova senha",
    "submitButton": "Alterar senha",
    "submittingButton": "Atualizando..."
  },
  "closeAccount": {
    "title": "Fechar conta",
    "subtitle": "Desative permanentemente sua conta. Se você tiver uma assinatura ativa, ela será cancelada. Esta ação não pode ser desfeita facilmente.",
    "openButton": "Quero fechar minha conta",
    "warning": "⚠️ Atenção: isso desativará sua conta, cancelará qualquer assinatura ativa, encerrará todas as sessões e não reembolsaremos assinaturas canceladas. Seus dados serão mantidos, mas sua conta ficará inacessível.",
    "passwordLabel": "Sua senha",
    "passwordPlaceholder": "Digite sua senha",
    "confirmLabel": "Digite",
    "confirmCode": "FECHAR MINHA CONTA",
    "confirmLabelEnd": "para confirmar",
    "confirmPlaceholder": "FECHAR MINHA CONTA",
    "cancelButton": "Cancelar",
    "submitButton": "Fechar conta permanentemente",
    "submittingButton": "Fechando..."
  },
  "contactUs": {
    "title": "Fale conosco",
    "body": "Entre em contato pelo",
    "discordName": "Flipping Pal Discord",
    "bodyEnd": "ou entre na nossa comunidade do Discord para dúvidas."
  }
}
